'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import type { ClothingItem, Outfit } from '@/types/closet';
import { Overlay } from './Overlay';
export function OutfitDetails(t0) {
  const $ = _c(11);
  const {
    outfit,
    items,
    onClose
  } = t0;
  const t1 = `${outfit.name} details`;
  let t2;
  if ($[0] !== outfit.name) {
    t2 = <h2>{outfit.name}</h2>;
    $[0] = outfit.name;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== items) {
    t3 = items.map(_temp);
    $[2] = items;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="outfit-detail-items">{t3}</div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== onClose || $[7] !== t1 || $[8] !== t2 || $[9] !== t4) {
    t5 = <Overlay label={t1} onClose={onClose} className="outfit-details">{t2}{t4}</Overlay>;
    $[6] = onClose;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
function _temp(item) {
  const href = item.url && /^https?:\/\//.test(item.url) ? item.url : undefined;
  return <article key={item.id}><Image unoptimized={true} src={item.imageUrl} alt={item.name} width={120} height={150} draggable={false} /><div>{item.brand && <p>{item.brand}</p>}<h3>{item.name}</h3>{item.size && <p>{item.size}</p>}{item.price !== undefined && <p>${item.price.toLocaleString("en-US")}</p>}{href && <a href={href} target="_blank" rel="noopener noreferrer">View ↗</a>}</div></article>;
}